import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import Filter from "views/TRM/filter"; // Importing Filter component
import Table from "views/TRM/table"; // Importing Table component
import {devConfig} from "config/config"; // Importing development configuration

export default class trmView extends JetView {
    config(){
        const _ = this.app.getService("locale")._; // Localization service for translations
        const theme = this.app.config.theme; // Retrieving the current theme from app config
        const toolbar = {
            view: "toolbar", id: "toolbar", // Defining a toolbar view
            css: "highlighted_header header6", // CSS classes for styling
            paddingX:5, paddingY:5, height:40, // Padding and height settings
            cols:[
                { 
                    view:"select", options:["10", "20", "50", "100", "1000"], width: 70, // Dropdown for selecting page size
                    on:{
                        onChange:function(){ // Event handler for change event
                            $$("datatable").getPager().config.size = this.getValue()*1; // Update pager size
                            $$("datatable").refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100,0); // Scroll to the top of the datatable
                        }
                    }
                },
                {
                    view: "pager", id: "pagerA", // Pager component for navigation
                    template: "{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}",
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch() // Default size from devConfig
                },
                {
                    view: "richselect", name: "Export", id:"Export", width:120, // Rich select for export options
                    placeholder: _("Exportar"), // Placeholder text for localization
                    options: [
                        {id:"1", value:"Excel"}, // Option for Excel export
                        {id:"2", value:"PDF"} // Option for PDF export
                    ],
                    on:{
                        "onChange":function(value){ // Event handler for change event
                            if(value==1){ // If Excel is selected
                                var table = $$("datatable"); // Reference to the datatable
                                for(var j=0;j<table.config.columns.length;j++){ // Loop through columns
                                    if(table.config.columns[j].exportType){ // Check for exportType
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, { // Export to Excel
                                    filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12:true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase()+ " - " + ($$("datatable").count()>0? "":_("No hay datos - "))+_("TRM"),
                                    ignore: {"detailTittle":true, "Action":true} // Ignore specific columns during export
                                });
                            }else{
                                if(value==2){ // If PDF is selected
                                    webix.toPDF($$("datatable"), { // Export to PDF
                                        filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12:true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase()+ " - " + ($$("datatable").count()>0? "":_("No hay datos - "))+_("TRM"),
                                        autowidth:true, // Auto width for PDF
                                        ignore: {"detailTittle":true, "Action":true} // Ignore specific columns during export
                                    });
                                }
                            }
                            $$("Export").setValue(""); // Reset export selection
                        }
                    }
                }
            ]
        };
        const left = {
            rows:[
                {
                    view:"toolbar", css:theme, // Toolbar with theme styling
                    elements:[
                        { view:"label", label:_("TRM Virtual Soft")}, // Label for the toolbar
                        {
                            type: "wide", css: "close-bottom",id:"button-search", // Search button
                            cols:[
                                {
                                    view:"icon", icon:"wxi-search",  bottom: 20, right: 35, width: 30, height: 30, // Search icon
                                    click:() => { // Click event to show filter popup
                                        $$("filterPopup").show();
                                    }
                                }
                            ]
                        }
                    ]
                },
                Filter, // Including Filter component
                Table, // Including Table component
                toolbar // Including toolbar defined above
            ]
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id:"as5", // Unique identifier for the view
            type: "clean", // Clean type for the form
            view:"form", // Form view
            scroll: "y", // Vertical scrolling enabled
            rows:[{
                responsive:"as5", // Responsive design identifier
                type:"wide", // Wide type for layout
                cols:[
                    left // Including left column layout
                ]
            }]
        };
    }
    init(grid) {
        webix.ready(function(){ // Ensure Webix is ready before executing
            if (screen.width < 500){ // Check for small screen width
                var childs = $$("toolbar").getChildViews(); // Get child views of the toolbar
                $$("toolbar").removeView(childs[2]); // Remove the third child view
                $$("pagerA").define("group", 1); // Define pager grouping
            };
            if (screen.width > 500 && screen.height > 500){ // Check for larger screens
                $$("button-search").hide(); // Hide search button
            }
            $.fn.scrollBottom = function() { // Custom function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height(); // Return scroll bottom value
            };
        });
    }
}

// FILE DOCUMENTED
